import './ReviewPendingComponent.scss';
import CardComponent from "../../../../shared/components/card/CardComponent";
import ProfileFoundCardComponent from "../../../../shared/components/profile-found-card/ProfileFoundCardComponent";
import ButtonComponent from "../../../../shared/components/button/ButtonComponent";
import React, {useState} from "react";
import RadioButtonComponent from "../../../../shared/components/form-controls/radio-button/radioButton";

import ModifyRequestFormComponent from '../modify-request/ModifyRequestFormComponent';

interface ReviewPendingComponentProps {
    selectedProfile: any;
    rejectClientRequest: () => void;
    approveClientRequest: (relationship?: string, permission_type?: string) => void;
    isApproveClientRequestLoading: boolean;
    closeDrawer?: any;
}


const ReviewPendingComponent = (props: ReviewPendingComponentProps) => {
    const {
        selectedProfile,
        rejectClientRequest,
        closeDrawer,
        approveClientRequest,
        isApproveClientRequestLoading
    } = props;

    const [selectedOption, setSelectedOption] = useState<string>('');


    return (
        <div className={'review-pending-component'}>
            <div
                className="drawer-header">{selectedProfile?.request_type === "grant_access" ? "Grant Access - Approval Pending" : "Access Request - Approval Pending"}</div>
            <CardComponent className="card-component-orange-bg-color">
                {selectedProfile?.request_type === "grant_access" && selectedProfile?.permission_type !== 'mutual' && <>
                    <div className={'main-heading-text'}>The user below is granting you access to their account. This
                        permission:
                    </div>
                    <ul className="pdd-left-25">
                        <li className={'pdd-bottom-20'}>Gives you access to all their information in their account.
                        </li>
                        <li className={'pdd-bottom-20'}>Gives you access to their account to book appointments and
                            manage
                            their account.
                        </li>
                        <li className={'pdd-bottom-20'}>Does not give them access to your account.
                        </li>
                        <li>
                            Can be changed at any time.
                        </li>
                    </ul>
                </>
                }
                {selectedProfile?.request_type === "grant_access" && selectedProfile?.permission_type === 'mutual' && <>
                    <div className={'main-heading-text'}>The user below is requesting access to your account. Granting <br/> this permission will :
                    </div>
                    <ul className="pdd-left-25">
                        <li className={'pdd-bottom-20'}>Give them full access to all the information in your account.
                        </li>
                        <li className={'pdd-bottom-20'}>Allow them to book appointments and manage your account on your behalf.

                        </li>
                        <li className={'pdd-bottom-20'}>Not affect your own access to your information, nor your ability to book appointments or manage your account.

                        </li>
                        <li>
                            Be changeable at any time.
                        </li>
                    </ul>
                </>
                }
                {selectedProfile?.request_type === "request_access" && <>
                    <div className={'main-heading-text'}>The user below is requesting access to your account. This
                        permission:

                    </div>
                    <ul className="pdd-left-25">
                        <li className={'pdd-bottom-20'}>Gives the other person access to all the information in your
                            account.

                        </li>
                        <li className={'pdd-bottom-20'}>Gives the other person access to book appointments and manage
                            your account on your behalf.

                        </li>
                        {selectedProfile?.permission_type === 'mutual' &&
                            <li className={'pdd-bottom-20'}>Gives you access to their account to book appointments and
                                manage their account.

                            </li>}
                        {selectedProfile?.permission_type !== 'mutual' &&
                            <li className={'pdd-bottom-20'}><b>Is not mutual - </b> you will not be able to access their
                                account.

                            </li>}
                        <li>
                            Can be changed at any time.
                        </li>
                    </ul>
                </>
                }
            </CardComponent>
            <div className={'profile-details-card-wrapper'}>
                <ProfileFoundCardComponent permissionType={selectedProfile?.permission_type}
                                           profileDetails={selectedProfile?.client_details}/>
            </div>
            <div className={"pdd-top-25"}>
                <CardComponent className="card-component-blue-bg-color">
                    <div className="terms-and-conditions-text">
                        <div className={'d-flex'}>
                            <div className={'pdd-top-15'}>
                                <RadioButtonComponent value="AGREE"
                                                      onChange={() => setSelectedOption('AGREE')}
                                                      checked={selectedOption === 'AGREE'}/>
                            </div>
                            <div className={'pdd-top-5'}><b>AGREE: </b>If you agree
                                to the terms listed above, select <b>Approve.</b>
                            </div>
                        </div>
                        <br/>
                        <div className={'d-flex'}>
                            <div className={'pdd-top-10'}>
                                <RadioButtonComponent value="DISAGREE"
                                                      onChange={() => setSelectedOption('DISAGREE')}
                                                      checked={selectedOption === 'DISAGREE'}/>
                            </div>
                            <div><b> DISAGREE: </b>
                                If you do not agree to the terms listed above, select <b> Reject </b>
                            </div>
                        </div>
                        <br/>

                        {selectedProfile?.request_type !== "grant_access" && <div className={'d-flex'}>
                            <div className={'pdd-top-10'}>
                                <RadioButtonComponent value="MODIFY"
                                                      onChange={() => setSelectedOption('MODIFY')}
                                                      checked={selectedOption === 'MODIFY'}/>
                            </div>
                            <div><b> MODIFY: </b>f you wish to modify the terms listed above, , select <b>Reject</b>,
                                and
                                send a new <b> Request Access </b> to the other person. The other person will
                                need to <b> Approve </b> the new terms of agreement from you before your
                                accounts will be linked.
                            </div>
                        </div>}
                    </div>
                </CardComponent>
                {
                    selectedOption === 'MODIFY' &&
                    <ModifyRequestFormComponent selectedProfile={selectedProfile}
                                                selectedOption={selectedOption}
                                                closeDrawer={closeDrawer}
                                                approveClientRequest={approveClientRequest}
                                                rejectClientRequest={rejectClientRequest}
                                                isApproveClientRequestLoading={isApproveClientRequestLoading}
                    />
                }

            </div>

            {selectedOption !== 'MODIFY' && <div className="t-form-actions">
                <ButtonComponent
                    color={'accent'}
                    variant={'outlined'}
                    // isLoading={isRejectRequestLoading}
                    disabled={!selectedOption || selectedOption === 'AGREE'}
                    onClick={() => rejectClientRequest()}
                >
                    Reject
                </ButtonComponent>
                <ButtonComponent
                    color={'accent'}
                    type={'button'}
                    className={'mrg-left-20'}
                    isLoading={isApproveClientRequestLoading}
                    disabled={!selectedOption || selectedOption === 'DISAGREE' || isApproveClientRequestLoading}
                    onClick={() => approveClientRequest()}
                    variant={'contained'}>
                    Approve
                </ButtonComponent>
            </div>}

        </div>)
}

export default ReviewPendingComponent;
